<template>
  <main class="flex-item">
    <div class="card">
      <header class="card-header page-title">
        <p class="card-header-title is-size-4"><span class="material-icons is-size-4">fact_check</span>重要事項説明、意向確認</p>
      </header>

      <div class="card-content">
        <div class="card">
          <header class="card-header">
            <div class="is-size-4 card-header-title header-center"><span class="material-icons accent-color">report</span>重要事項説明</div>
          </header>
          <div class="card-content has-text-centered">
            <p class="mb-5">ご契約前に、重要事項（「契約概要」「注意喚起情報」）を必ずお読みください</p>
            <div class="columns is-centered">
              <div class="column is-6 has-text-centered primary-text">
                <div class="field">
                  <div class="control">
                    <a
                      class="button is-medium is-fullwidth accent-color-bg w-space-normal h-auto"
                      @click="importantRead = true"
                      href="/pdf/important.pdf"
                      target="_blank"
                      rel="noopener"
                      >重要事項説明書をダウンロード</a
                    >
                  </div>
                </div>
              </div>
            </div>
            <input type="checkbox" v-model="form.tf_rejyjk" :disabled="!importantRead" id="important-agree" class="check-type-1" />
            <label for="important-agree" class="primary-text">重要事項説明書に同意する</label>
            <ErrorField :error="f$.tf_rejyjk.$errors" />
          </div>
        </div>
      </div>

      <div class="card-content">
        <div class="card">
          <header class="card-header">
            <div class="is-size-4 card-header-title header-center">
              <span class="material-icons accent-color">announcement</span>保険契約上の意向確認
            </div>
          </header>
          <div class="card-content has-text-centered">
            <table class="table border-divider-color is-bordered mx-auto">
              <tbody>
                <tr>
                  <td class="has-text-left">この保険は「家財」と「賠償責任」を保険の対象としています。ご確認頂けましたか？</td>
                  <td class="w-space-nowrap">
                    <input type="checkbox" v-model="form.target_verify" id="target-verify-yes" name="target-verify" class="check-type-1" />
                    <label for="target-verify-yes" class="primary-text">はい</label>
                  </td>
                </tr>
                <tr>
                  <td class="has-text-left">地震保険が付帯されていないことをご確認いただきましたか？</td>
                  <td class="w-space-nowrap">
                    <input
                      type="checkbox"
                      v-model="form.earthquake_verify"
                      id="earthquake-verify-yes"
                      name="earthquake-verify"
                      class="check-type-1"
                    />
                    <label for="earthquake-verify-yes" class="primary-text">はい</label>
                  </td>
                </tr>
                <tr>
                  <td class="has-text-left">「保険金をお支払いできない場合」や「ご契約後の通知義務」についてご確認いただけましたか？</td>
                  <td class="w-space-nowrap">
                    <input
                      type="checkbox"
                      v-model="form.notification_verify"
                      id="notification-verify-yes"
                      name="notification-verify"
                      class="check-type-1"
                    />
                    <label for="notification-verify-yes" class="primary-text">はい</label>
                  </td>
                </tr>
              </tbody>
            </table>
            <ErrorField :error="intentionError" />
          </div>
        </div>
      </div>

      <div class="card-content">
        <div class="card">
          <header class="card-header">
            <div class="is-size-4 card-header-title header-center">
              <span class="material-icons accent-color">priority_high</span>当社保険加入状況の確認
            </div>
          </header>
          <div class="card-content has-text-centered">
            <p class="has-text-centered mb-1">ご入居される方の中に「SANKOライフガード」または「SANKOライフ保険」に現在ご加入中の方はおられますか？</p>
            <p class="has-text-centered mb-5">※現在ご加入の満期を迎えるご契約は除きます。</p>
            <div class="columns is-justify-content-center">
              <div class="field">
                <div class="control">
                  <input
                    type="radio"
                    v-model="form.another_contract"
                    :value="constants.ARI.ARI"
                    id="own-other-contract-yes"
                    class="radio-type-2"
                    name="own-other-contract"
                    @focus="f$.another_contract.$reset()"
                    @change="f$.another_contract.$touch()"
                  />
                  <label for="own-other-contract-yes" class="mr-6">はい</label>
                  <input
                    type="radio"
                    v-model="form.another_contract"
                    :value="''"
                    id="own-other-contract-no"
                    class="radio-type-2"
                    name="own-other-contract"
                    @focus="f$.another_contract.$reset()"
                    @change="f$.another_contract.$touch()"
                  />
                  <label for="own-other-contract-no">いいえ</label>
                </div>
              </div>
            </div>
            <ErrorField :error="f$.another_contract.$errors" />
          </div>
        </div>
      </div>

      <footer v-if="!mailFormVisible" class="card-footer">
        <div class="card-footer-item">
          <span class="mr-4">
            <button class="card-footer-item button accent-color-bg is-normal is-medium" @click="noMail">更新内容の入力へ進む</button>
          </span>
          <span>
            <router-link :to="{ name: 'Top' }" class="card-footer-item button is-normal is-medium">キャンセル</router-link>
          </span>
        </div>
      </footer>

      <div v-if="mailFormVisible" class="card-content">
        <div class="card">
          <header class="card-header">
            <div class="is-size-4 card-header-title header-center"><span class="material-icons accent-color">email</span>メールアドレス登録</div>
          </header>
          <div class="card-content has-text-centered">
            <div class="columns is-justify-content-center">
              <div class="important-info">
                <p class="has-text-centered mb-4">お申込み用のメールアドレスを登録してください<br />申込開始メールをお送りします</p>
                <div class="columns is-centered">
                  <div class="column is-12">
                    <div class="field">
                      <div class="control has-icons-left">
                        <input
                          class="input"
                          type="email"
                          v-model="form.tf_rekyma"
                          @focus="f$.tf_rekyma.$reset(), f$.$clearExternalResults()"
                          @blur="f$.tf_rekyma.$touch()"
                        />
                        <span class="icon is-small is-left">
                          <span class="material-icons">email</span>
                        </span>
                      </div>
                    </div>
                    <p class="text-info has-text-centered">
                      ※契約者様のメールアドレスで、この場ですぐに確認できるアドレスをご指定ください
                    </p>
                  </div>
                </div>
                <ErrorField :error="f$.tf_rekyma.$errors" />
                <p class="has-text-centered mb-4">
                  入力されたメールアドレスに確認番号を送付致します<br />確認番号が届きましたら、次画面で確認番号を入力してください
                </p>
                <div class="field mb-5">
                  <div class="control has-text-centered">
                    <a class="button is-medium accent-color-bg px-6" @click="send">送信</a>
                    <router-link :to="{ name: 'Top' }" class="button is-normal is-medium ml-2">キャンセル</router-link>
                  </div>
                </div>
                <p class="has-text-centered"><a @click="noMail">メールアドレスのない方はこちら</a></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script lang="ts">
import { getContract } from "@/api/contract";
import { getRenewal } from "@/api/renewal";
import router from "@/router";
import { MutationTypes, useStore } from "@/store";
import ErrorField from "common/src/components/ErrorField.vue";
import { computed, defineComponent, reactive, ref, UnwrapRef } from "vue";
import { SCR131Form, SCR131FormValidateRule } from "@/forms/scr131";
import useVuelidate from "@vuelidate/core";
import constants from "common/src/constants";
import { scrollToError } from "common/src/utils/screen";
import { ConfirmRequest, postConfirmRequest } from "@/api/confirm";
import axios from "axios";
import { setErrorMessage } from "common/src/utils/validate";
import { ErrorResponse } from "common/src/utils/request";

export default defineComponent({
  components: {
    ErrorField,
  },
  setup() {
    const importantRead = ref(false);
    const mailFormVisible = ref(false);
    // フォーム変数作成
    const form: UnwrapRef<SCR131Form> = reactive({
      tf_rejyjk: false,
      target_verify: false,
      earthquake_verify: false,
      notification_verify: false,
      another_contract: undefined,
      tf_rekyma: undefined,
    });
    const store = useStore();

    getContract().then((con) => {
      getRenewal().then((ren) => {
        if (ren.data.rnw01p?.tf_rekzis === constants.KEIZOKU_ISHI.ARI) {
          // 継続意思有の場合は404ページへ
          router.push({ name: "404" });
        } else if (con.data.kei01p?.tf_kehscd === ren.data.rnw01p?.tf_rehscd) {
          // 契約データの商品コードと更新データの商品コードが一致する場合は重要事項説明は不要
          store.commit(MutationTypes.SET_NEED_DISCLOSURE, false);
          router.push({ name: "Renewal" });
          return;
        } else {
          // 更新データにメールアドレスがある場合は、メールフォームは非表示
          mailFormVisible.value =
            ren.data.rnw01p?.tf_rekyma === undefined || ren.data.rnw01p?.tf_rekyma === null || ren.data?.rnw01p.tf_rekyma === "";

          // ストアの確認が必要かどうかによって処理を分岐
          if (store.state.needDisclosure === undefined) {
            store.commit(MutationTypes.SET_NEED_DISCLOSURE, true);
          } else if (!store.state.needDisclosure) {
            // 一度、確認を行っている場合は値を復元
            form.tf_rejyjk = true;
            form.target_verify = true;
            form.earthquake_verify = true;
            form.notification_verify = true;
            form.another_contract = store.state.hasAnother;

            if (store.state.mail) {
              form.tf_rekyma = store.state.mail;
            }
          }
        }
      });
    });

    // 全体エラーメッセージ
    const g$: string[] = reactive([]);

    // フィールドエラーを外部からセットする変数
    const $externalResults = ref({});
    // フィールドエラー設定初期化
    const f$ = useVuelidate(SCR131FormValidateRule, form, {
      $externalResults,
    });
    // 意向確認のエラーを１つだけ表示
    const intentionError = computed(() => {
      if (f$.value.target_verify.$error || f$.value.earthquake_verify.$error || f$.value.notification_verify.$error) {
        return [...f$.value.target_verify.$errors, ...f$.value.earthquake_verify.$errors, ...f$.value.notification_verify.$errors][0].$message;
      }
      return "";
    });

    // 本人確認リクエストのメールを送付します
    const send = async () => {
      f$.value.$clearExternalResults();

      // メールアドレスが必須なのは本人確認リクエストを行う場合のみなので手動チェック
      if (form.tf_rekyma === "" || form.tf_rekyma === null || form.tf_rekyma === undefined) {
        $externalResults.value = { tf_rekyma: "メールアドレスを入力してください" };
      }
      f$.value.$touch();
      if (f$.value.$invalid) {
        scrollToError();
        return;
      }

      try {
        // API0210呼び出し
        const req: ConfirmRequest = {
          mailAddress: form.tf_rekyma ?? "",
        };
        const res = await postConfirmRequest(req);

        // ストアへシリアル番号をCommit
        store.commit(MutationTypes.SET_RENEWAL_SERIAL, res.serialNo);
        store.commit(MutationTypes.SET_NEED_DISCLOSURE, false);
        store.commit(MutationTypes.SET_ANOTHER, form.another_contract);
        store.commit(MutationTypes.SET_MAIL, form.tf_rekyma);

        // SCR132 確認メール送信結果画面へ遷移
        router.push({ name: "Confirm" });
      } catch (err) {
        if (axios.isAxiosError(err) && err.response?.status === 400) {
          setErrorMessage(g$, $externalResults, err.response?.data as ErrorResponse);
        }
      }
    };

    // メールアドレスがない方・更新内容入力へ進むをクリック時
    const noMail = () => {
      f$.value.$clearExternalResults();
      f$.value.$touch();
      if (f$.value.$invalid) return;

      store.commit(MutationTypes.SET_NEED_DISCLOSURE, false);
      store.commit(MutationTypes.SET_RENEWAL_SERIAL, "");
      store.commit(MutationTypes.SET_ANOTHER, form.another_contract);

      // SCR130更新内容入力画面へ移動
      router.push({ name: "Renewal" });
    };

    return {
      importantRead,
      mailFormVisible,
      form,
      g$,
      f$,
      intentionError,
      constants,
      send,
      noMail,
    };
  },
});
</script>
